import React from 'react';
import noop from '../../../utils/noop';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import { FullViewProps } from '../../../DeviationViews/Full/types';
import { DeviantMediaWrapper } from '../../../utils/DeviationMediaService/types';
import ZoomModal from '../../../DeviationViews/ZoomModal';
import { useFullview } from '../../../DeviationViews/Full/hooks/useFullview';

export interface ZoomModalFromImageSourceProps extends Pick<
  FullViewProps,
  'isZoomed' | 'onExitZoomMode' | 'width' | 'height'
> {
  source: DeviantMediaWrapper;
  allowFullviewSrcsetForPngs?: boolean;
}

export const ZoomModalFromImageSource: React.FC<ZoomModalFromImageSourceProps> = ({
  source,
  width,
  height,
  allowFullviewSrcsetForPngs = false,
  isZoomed,
  onExitZoomMode = noop,
}) => {
  const { srcFile, isPixel } = useFullview({
    stageWidth: width ?? 0,
    stageHeight: height ?? 0,
    source,
    allowFullviewSrcsetForPngs,
  });

  return (
    isZoomed &&
    srcFile && (
      <ZoomModal
        src={srcFile.src}
        srcSet={getSrcSet(source)}
        width={srcFile.width}
        height={srcFile.height}
        isPixel={!!isPixel}
        onClose={() => onExitZoomMode(source)}
      />
    )
  );
};

export default ZoomModalFromImageSource;
